import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

export interface OpDrawerElement extends HTMLElement {
  visible: boolean;
  onClose: () => void;
}

const OpDrawer = createWrapper<OpDrawerElement>('op-drawer', {
  onClose: 'onClose',
});

export default OpDrawer;
